import req from "@/assets/js/axios"

// 用户相关接口
export default {
  /** 修改默认园区*/
  updateDefaultEnterprise: (params) => {
    return req.apiAxios('POST', '/business/extend/BExtendController/starry-security/updateDefaultEnterprise', params, true);
  },
}
